import { Stack, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../../theme";

interface FreeStreamsHeroProps {
  title: string;
  subtitle: string;
}

const FreeStreamsHero = ({ title, subtitle }: FreeStreamsHeroProps) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Stack sx={{ pt: "160px", pb: "48px", alignItems: "center" }} spacing={3}>
      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 900,
          fontSize: "56px",
          color: "primary.main",
          textAlign: "center",
          lineHeight: "64px",
          maxWidth: "765px",
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Mulish",
          fontWeight: 400,
          fontSize: "16px",
          color: colors.primary[700],
          textAlign: "center",
        }}
      >
        {subtitle}
      </Typography>
    </Stack>
  );
};

export default FreeStreamsHero;
